'use strict';

function initializeProfessionalInfoEvents() {
    $(document).on('change', '.js-registration-professional-info .js-professional_name', function() {
        var $checkbox = $(this);
        var $professionalDetails = $checkbox.closest('.js-registration-professional-info').find('.js-professional-details');
        var $requiredFields = $professionalDetails.find('input');

        if ($checkbox.is(':checked')) {
            $professionalDetails.removeClass('hidden').show();

            $requiredFields.each(function() {
                $(this).removeClass('js-validate-ignore')
                       .attr('required', 'required')
                       .addClass('required');
            });
        } else {
            $professionalDetails.addClass('hidden').hide();

            $requiredFields.each(function() {
                $(this).addClass('js-validate-ignore')
                       .removeAttr('required')
                       .removeClass('required error')
                       .val('');

                $(this).closest('.form-row').removeClass('error');
                $(this).parent().next('.error').remove();
            });
        }

        var $form = $checkbox.closest('form');
        if ($form.length && $form.data('validator')) {
            $form.validate().resetForm();
        }
    });
}

function initializeFormState() {
    var $checkbox = $('.js-registration-professional-info .js-professional_name');
    var $professionalDetails = $('.js-professional-details');
    var $requiredFields = $professionalDetails.find('input');

    if (!$checkbox.is(':checked')) {
        $professionalDetails.addClass('hidden').hide();
        $requiredFields.addClass('js-validate-ignore')
                      .removeAttr('required')
                      .removeClass('required');
    } else {
        $professionalDetails.removeClass('hidden').show();
        $requiredFields.removeClass('js-validate-ignore')
                      .attr('required', 'required')
                      .addClass('required');
    }
}

function initializeEvents() {
    initializeProfessionalInfoEvents();
    initializeFormState();
}

var registrationretail = {
    init: function () {
        initializeEvents();
    }
};

module.exports = registrationretail;